module.exports = __webpack_public_path__ + "static/media/estate_appraiser.a4d84038.jpg";